import { OnInit } from '@angular/core';
export var badgeRenditionEnum;
(function (badgeRenditionEnum) {
    badgeRenditionEnum[badgeRenditionEnum[""] = 0] = "";
    badgeRenditionEnum[badgeRenditionEnum["secondary"] = 1] = "secondary";
})(badgeRenditionEnum || (badgeRenditionEnum = {}));
export var badgePositionEnum;
(function (badgePositionEnum) {
    badgePositionEnum[badgePositionEnum[""] = 0] = "";
    badgePositionEnum[badgePositionEnum["tr"] = 1] = "tr";
    badgePositionEnum[badgePositionEnum["bc"] = 2] = "bc";
})(badgePositionEnum || (badgePositionEnum = {}));
var BadgeComponent = /** @class */ (function () {
    function BadgeComponent() {
        this.rendition = '';
        this.position = '';
        this.classes = [];
    }
    BadgeComponent.prototype.ngOnInit = function () {
    };
    return BadgeComponent;
}());
export { BadgeComponent };
